/**
 * @file Stopped.jsx
 * @exports Stopped
 */
import React from 'react'

const red = '#D00000'
const defaultColor = red

const Stopped = function Stopped ({ style }) {
  return (
    <svg
      id='stopped-icon'
      preserveAspectRatio='xMidYMid meet'
      style={style}
      viewBox='0 0 20 20'
    >
      <description>equipment is stopped icon</description>
      <title>stopped</title>
      <circle stroke={defaultColor} strokeWidth='2' fill='white' cx='9' cy='10' r='9' />
      <rect fill={defaultColor} x='5' y='6' width='8' height='8' rx='0.5' />
    </svg>
  )
}

export default Stopped
